import { render, staticRenderFns } from "./UserUpdateDialogName.vue?vue&type=template&id=1825b493&scoped=true"
import script from "./UserUpdateDialogName.vue?vue&type=script&lang=ts"
export * from "./UserUpdateDialogName.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1825b493",
  null
  
)

export default component.exports